<!-- 全部订单 -->

<template>
  <div class="view-container" v-loading="loading">
    <!-- 筛选内容 -->
    <div class="sizer-content">
      <div class="flex-column-item">
        <!-- 第一行 -->
        <div style="flex: 1">
          <el-date-picker
            style="width: 100%"
            v-model="form.value1"
            type="datetimerange"
            :picker-options="pickerOptions"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            align="center"
          >
          </el-date-picker>
        </div>
        <el-input
          v-model="form.orderNo"
          placeholder="请输入卡订单号"
          style="flex: 1; padding: 0px 30px"
        ></el-input>
        <div style="flex: 1">
          <el-select
            v-model="form.prodType"
            placeholder="卡类（全部）"
            style="width: 100%"
            @change="prodTypeClick"
          >
            <el-option
              v-for="item in typeList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
      </div>
      <!--第二行 -->
      <div class="flex-column-item" style="margin-top: 20px">
        <div style="flex: 1">
          <el-select
            v-model="form.prodCode"
            placeholder="卡种（全部）"
            style="width: 100%"
            @change="prodCodeClicK"
          >
            <el-option
              v-for="item in kindList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>

        <div style="flex: 1; padding: 0px 30px">
          <el-select
            v-model="form.faceValue"
            placeholder="面值（全部）"
            style="width: 100%"
          >
            <el-option
              v-for="item in fvList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>

        <div style="flex: 1">
          <el-select
            v-model="form.settStatus"
            placeholder="请选择结算状态"
            style="width: 100%"
          >
            <el-option key="0" label="未结算" value="0"> </el-option>
            <el-option key="1" label="已结算" value="1"> </el-option>
          </el-select>
        </div>
      </div>
      <!-- 第三行 -->
      <div class="flex-column-item" style="margin-top: 20px">
        <div style="flex: 1">
          <el-select
            v-model="form.status"
            placeholder="请选择订单状态"
            style="width: 100%"
          >
            <el-option key="1" label="成功" value="1"> </el-option>
            <el-option key="2" label="处理中" value="2"> </el-option>
            <el-option key="3" label="失败" value="3"> </el-option>
          </el-select>
        </div>

        <div style="flex: 1; padding: 0px 30px">
          <el-select
            v-model="form.submitType"
            placeholder="请选择提交类型"
            style="width: 100%"
          >
            <el-option key="1" label="单卡" value="1"> </el-option>
            <el-option key="2" label="批量" value="2"> </el-option>
          </el-select>
        </div>

        <div class="fold-view" style="flex: 1">
          <!-- <el-button size="small">重置</el-button> -->
          <el-button type="primary" @click="orderList" style="width: 100px"
            >查询</el-button
          >
          <el-button plain @click="orderexport" style="width: 100px"
            >导出订单</el-button
          >
          <el-button @click="resetForm" style="width: 100px">重置</el-button>
        </div>
      </div>
    </div>
    <div class="hint-view">
      <img src="@/assets/image/hint-image.png" alt="" />
      <label>
        全部订单中取消订单、修改折扣是按单卡处理，如果需要批量修改可在批量订单中操作。
      </label>
    </div>
    <!-- 表格 -->
    <div class="tab-view">
      <el-table
        :data="tableData"
        style="width: 100%"
        max-height="500"
        :header-cell-style="{
          backgroundColor: ' rgb(235, 237, 244)',
          color: 'black',
          fontSize: '14px',
          fontWeight: '600',
        }"
      >
        <el-table-column fixed prop="batchNo" label="订单号" width="180">
        </el-table-column>
        <el-table-column prop="orderNo" label="卡订单号" width="120">
        </el-table-column>
        <el-table-column prop="cardNum" label="卡号" width="120">
        </el-table-column>
        <el-table-column prop="prodName" label="卡种" width="120">
        </el-table-column>
        <el-table-column prop="faceValue" label="提交面值" width="100">
        </el-table-column>
        <el-table-column prop="actualFaceValue" label="实际面值" width="100">
        </el-table-column>
        <el-table-column prop="rate" label="供货折扣" width="100">
        </el-table-column>
        <el-table-column prop="amount" label="实际可得" width="100">
        </el-table-column>
        <el-table-column prop="submitTime" label="提交时间" width="120">
        </el-table-column>
        <el-table-column prop="handleTime" label="处理时间" width="120">
        </el-table-column>
        <el-table-column prop="settTime" label="结算时间" width="120">
        </el-table-column>
        <el-table-column prop="diffTime" label="耗时" width="100">
        </el-table-column>
        <el-table-column prop="status" label="订单状态" width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.status == 1" class="open">成功</span>
            <span v-else-if="scope.row.status == 2" class="processing"
              >处理中</span
            >
            <span v-else-if="scope.row.status == 3" class="rejected">失败</span>
          </template>
        </el-table-column>
        <el-table-column prop="notes" label="备注" width="150">
          <template slot-scope="scope">
            <span v-if="scope.row.status != 1">{{ scope.row.notes }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="settStatus" label="结算状态" width="120">
          <template slot-scope="scope">
            <span v-if="scope.row.settStatus == 0" class="rejected">未结算</span>
            <span v-else-if="scope.row.settStatus == 1" class="open">已结算</span>
          </template>
        </el-table-column>
        <el-table-column prop="submitType" label="提交方式" width="120">
        </el-table-column>
        <el-table-column label="操作" align="center" fixed="right">
          <template slot-scope="scope" fixed>
            <el-button size="mini" type="text" @click="handleUpdate(scope.row)"
              >查看详情</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div
      style="
        margin-top: 30px;
        display: flex;
        justify-content: flex-end;
        padding-right: 30px;
      "
    >
      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="form.pageNum"
        :limit.sync="form.pageSize"
        @pagination="orderList()"
      />
    </div>
    <!-- 查看详情 -->
    <el-dialog
      title="订单详情"
      :visible.sync="dialogVisible"
      width="40%"
      :before-close="handleClose"
    >
      <el-form :model="formInline" label-width="100px" class="detail-form">
        <el-form-item label="订单号">
          <el-input v-model="formInline.batchNo" disabled></el-input>
        </el-form-item>
        <el-form-item label="卡订单号">
          <el-input v-model="formInline.orderNo" disabled></el-input>
        </el-form-item>
        <el-form-item label="卡号">
          <el-input v-model="formInline.cardNum" disabled></el-input>
        </el-form-item>
        <el-form-item label="卡种">
          <el-input v-model="formInline.prodName" disabled></el-input>
        </el-form-item>
        <el-form-item label="提交面值">
          <el-input v-model="formInline.faceValue" disabled></el-input>
        </el-form-item>
        <el-form-item label="实际面值">
          <el-input v-model="formInline.actualFaceValue" disabled></el-input>
        </el-form-item>
        <el-form-item label="供货折扣">
          <el-input v-model="formInline.rate" disabled></el-input>
        </el-form-item>
        <el-form-item label="实际可得">
          <el-input v-model="formInline.amount" disabled></el-input>
        </el-form-item>
        <el-form-item label="提交时间">
          <el-input v-model="formInline.submitTime" disabled></el-input>
        </el-form-item>
        <el-form-item label="处理时间">
          <el-input v-model="formInline.handleTime" disabled></el-input>
        </el-form-item>
        <el-form-item label="结算时间">
          <el-input v-model="formInline.settTime" disabled></el-input>
        </el-form-item>
        <el-form-item label="耗时">
          <el-input v-model="formInline.diffTime" disabled></el-input>
        </el-form-item>
        <el-form-item label="订单状态">
          <el-select v-model="formInline.status" disabled>
            <el-option label="成功" value="1"></el-option>
            <el-option label="处理中" value="2"></el-option>
            <el-option label="失败" value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="结算状态">
          <el-select v-model="formInline.settStatus" disabled>
            <el-option label="未结算" value="0"></el-option>
            <el-option label="已结算" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="提交方式">
          <el-input v-model="formInline.submitType" disabled></el-input>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import http from "@/utils/http/axios";
import axios from "axios";
import Cokie from "js-cookie";
export default {
  mounted() {
    this.dictType();
    this.orderList();
  },
  data() {
    return {
      formInline: {},
      dialogVisible: false,
      total: 0,
      sizerOpne: 0,
      form: {
        value1: null,
        orderNo: "",
        prodType: "",
        prodCode: "",
        faceValue: "",
        settStatus: "",
        status: "",
        submitType: "",
        pageNum: 1,
        pageSize: 10,
      },
      typeList: [],
      kindList: [],
      fvList: [],
      loading: false,
      pickerOptions: {
        shortcuts: [
          {
            text: "本月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setDate(1);
              end.setMonth(end.getMonth() + 1);
              end.setDate(0);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "今年至今",
            onClick(picker) {
              const end = new Date();
              const start = new Date(new Date().getFullYear(), 0);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近六个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setMonth(start.getMonth() - 6);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      currentPage4: 4,
      tableData: [],
    };
  },

  methods: {
    // 查看详情
    handleUpdate(row) {
      this.dialogVisible = true;
      this.formInline = { ...row }; // 将选中行的数据复制到表单对象
    },
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.formInline = {}; // 清空表单数据
    },
    // 卡类选择
    prodTypeClick(e) {
      this.divtfv(e);
    },
    //卡类字典
    dictType() {
      http
        .get("/product/type/dict")
        .then((response) => {
          if (response.code == 200) {
            this.typeList = response.data;
          }
        })
        .catch((error) => {
          this.$message.error("发生意外异常");
        });
    },
    //卡值字典
    divtfv(e) {
      http
        .get("/product/dict?prodType=" + e)
        .then((response) => {
          if (response.code == 200) {
            this.kindList = response.data;
          }
        })
        .catch((error) => {
          this.$message.error("发生意外异常");
        });
    },
    // 费率字典
    prodCodeClicK(e) {
      http
        .get("/product/fv/dict?prodCode=" + e)
        .then((response) => {
          if (response.code == 200) {
            this.fvList = response.data;
          }
        })
        .catch((error) => {
          this.$message.error("发生意外异常");
        });
    },
    // 订单列表
    orderList() {
      if (this.form.value1) {
        const startDate = this.formatDate(this.form.value1[0]);
        const endDate = this.formatDate(this.form.value1[1]);
        this.form.endDate = endDate;
        this.form.startDate = startDate;
        delete this.form.value1;
      }
      http
        .post(
          "/order/list?pageNum=" +  this.form.pageNum + "&pageSize=" + this.form.pageSize,
          this.form
        )
        .then((response) => {
          console.log(response);
          if (response.code == 200) {
            this.total = response.total;
            this.tableData = response.rows;
          }
        })
        .catch((error) => {
          this.$message.error("发生意外异常");
        });
    },
    //订单导出
    orderexport() {
      this.loading = true;
      if (this.form.value1) {
        const startDate = this.formatDate(this.form.value1[0]);
        const endDate = this.formatDate(this.form.value1[1]);
        this.form.endDate = endDate;
        this.form.startDate = startDate;
      }
      axios.defaults.headers.common["Authorization"] = `Bearer ${Cokie.get(
        "token"
      )} `;
      axios({
        method: "get",
        url: "https://m.huishouka.com.cn/order/list/export",
        params: this.form,
        responseType: "arraybuffer",
      })
        .then((res) => {
          this.loading = false;
          let url = window.URL.createObjectURL(
            new Blob([res.data], { type: ".xlsx" })
          );
          let a = document.createElement("a");
          a.style.display = "none";
          a.href = url;
          a.setAttribute("download", `订单统计.xlsx`);
          document.body.appendChild(a);
          a.click();
          url = window.URL.revokeObjectURL(url);
          document.body.removeChild(a);
        })
        .catch((err) => {
          this.loading = false;
          console.log(err);
        });
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
    },
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      const seconds = String(date.getSeconds()).padStart(2, "0");
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    convertDate(isoDateString) {
      const date = new Date(isoDateString);
      return this.formatDate(date);
    },
    // 添加重置方法
    resetForm() {
      // 重置表单数据
      this.form = {
        value1: null,
        orderNo: "",
        prodType: "",
        prodCode: "",
        faceValue: "",
        settStatus: "",
        status: "",
        submitType: "",
        pageNum: 1,
        pageSize: 10,
      };

      // 重置卡种和面值的选项列表
      this.kindList = [];
      this.fvList = [];

      // 重置后自动查询
      this.orderList();
    },
  },
};
</script>

<style lang="less" scoped>
.sizer-view {
  padding: 0px 30rpx;
  display: flex;
  align-items: center;
  font-size: 16px;
  height: 80px;
  color: #488eff;
  font-weight: 600;
  background-color: white;
  padding-left: 30px;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;

  img {
    width: 24px;
    height: 24px;
    margin-left: 10px;
  }
}

.sizer-content {
  background-color: white;
  padding: 30px 30px;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  .flex-column();

  .flex-column-item {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .fold-view {
      display: flex;
      align-items: center;
    }
  }
}

.view-container {
  background-color: white;
  height: 100%;

  .hint-view {
    margin: 0px 30px;
    height: 40px;
    color: rgb(169, 83, 0);
    background: rgb(255, 244, 219);
    display: flex;
    align-items: center;
    font-size: 12px;
    color: rgb(169, 83, 0);
    padding: 0px 20px;
    border-radius: 10px;

    img {
      width: 28px;
      height: 28px;
      margin-right: 10px;
    }
  }

  .tab-view {
    border: 2px solid #ebeef5;
    margin: 0px 30px;
    border-radius: 5px;
    margin-top: 20px;
  }
}

.detail-form {
  max-height: 60vh;
  overflow-y: auto;
  padding: 0 20px;

  /deep/ .el-form-item {
    margin-bottom: 18px;

    .el-input.is-disabled .el-input__inner {
      color: #606266;
      background-color: #f5f7fa;
    }

    .el-select.is-disabled .el-input__inner {
      color: #606266;
      background-color: #f5f7fa;
    }
  }
}

.el-dialog {
  /deep/ .el-dialog__body {
    padding: 10px 0;
  }
}
</style>
